export class VersioningLine {
  indexWithPrefix: string;
  bannerWebPath: string;

  constructor(data: any) {
    this.indexWithPrefix = data.indexWithPrefix;
    this.bannerWebPath = data.bannerWebPath;
  }
}
